export default __webpack_public_path__ + "static/media/close-item.37c2da2b.svg";